(function() {

    'use strict';

    /**
     * @module Plugins
     *
     * SAPO Analytics plugin. Reports back KPI information for SAPO Vídeos.
     *
     * @namespace sv_analytics
     */

    var Feat = SAPO.Project.Video.Features;
    var Utility = SAPO.Utility;


    var genId = function(prefix) {
        return prefix + ( ~~(Math.random() * Math.pow(32, 6)) ).toString(32);
    };

    var arrIndexOf = Utility.arrIndexOf;


    var plugin = function(vc, ui, pub, pubD, v) {
        this._vc = vc;
        this._ui = ui;
        this._pub = pub;
        this._pubD = pubD;
        this._v = v;

        this._md = {};

        this._kpis = undefined;
        this._kpiEvents = {};
        this._cache = {};
        this._preRoll = false;

        if ( this._vc.getOption('skipSVAnalytics') ) { return; }

        this._vc.subscribe('button_activated ended h_mute h_resize h_scrub h_state_changed h_volume_changed load metadata_changed sv_analytics_kill_endpoint', undefined, this);
    };

    plugin.prototype = {

        _name: plugin._name = 'sv_analytics',

        on_load: function(mt, o) {
            //console.log('LOAD', o);
            this._ended = false;

            // Review this for a better condition before implementing full mid-roll and post-roll support!
            this._preRoll = o.isAd;

            this._requestURL = o.requestURL;
            this._guidURL = o.guidURL;
            this._pub('remove_timeline_prefix', 'analytics_', o.requestURL);

            if (o.isLive || o.isAd) {
                if (this._kpis) {
                    this._kpis = undefined;
                    this._kpiEvents = {};
                }

                if (o.isAd) {
                    if (this._kpis) {
                        this._kpis = undefined;
                        this._kpiEvents = {};
                    }
                    this._fetchEndpoints();
                }
                /*else {
                    console.log('no kpis for you');
                }*/

                return;
            }

            this._fetchEndpoints(o);
        },

        on_metadata_changed: function(mt, md) {
            if (md.isAd || md.isLive) { return; }

            // console.log('metadata_changed', md);
            this._md = md;
        },

        on: function(mt) {
            /*jshint maxcomplexity:40 */

            if (!this._kpis || this._preRoll) { return; /*console.log('NO KPIS?', !this._kpis, 'PREROLL?', this._preRoll)*/ }

            var args = Array.prototype.slice.call(arguments); args.shift();
            var a0 = args[0];

            var kEvs = this._kpiEvents;
            var t;

            switch(mt) {
                case 'button_activated':
                    switch (a0) {
                        case 'sv-share':
                            this._pub('metro', kEvs.clickShare, 'svkpi_clickShare');
                            break;

                        case 'quality-sd':
                            this._pub('metro', kEvs['clickHd'], 'svkpi_clickHd');
                            break;

                        case 'quality-hd':
                            this._pub('metro', kEvs['clickSd'], 'svkpi_clickSd');
                            break;
                    }
                    break;

                case 'ended':
                    this._pub('metro', kEvs.complete, 'svkpi_complete');
                    this._ended = true;
                    break;

                case 'h_mute':
                    t = (a0 ? 'clickMute' : 'clickUnMute');
                    this._pub('metro', kEvs[t], 'svkpi_' + t);
                    break;

                case 'h_resize':
                    if (a0 === this._lastResize) { break; }
                    t = ((a0 === 'full') ? 'clickFullScreenOn' : 'clickFullScreenOff');
                    this._pub('metro', kEvs[t], 'svkpi_' + t);
                    this._lastResize = a0;
                    break;

                case 'h_scrub':
                    this._pub('metro', kEvs.clickSeek, 'svkpi_clickSeek');
                    this._ended = false;
                    break;

                case 'h_state_changed':
                    t = a0 === 'play' ? 'clickPlay' : 'clickPause';
                    this._pub('metro', kEvs[t], 'svkpi_' + t);
                    if (this._ended) {
                        this._ended = false;
                        t = 'clickReview';
                        this._pub('metro', kEvs[t], 'svkpi_' + t);
                    }
                    break;

                case 'h_volume_changed':
                    t = a0 === 'up' ? 'volumeUp' : 'volumeDown';
                    this._pub('metro', kEvs[t], 'svkpi_' + t);
                    break;

                case 'sv_analytics_kill_endpoint':
                    var idx = arrIndexOf(this._kpis.events, a0);
                    if (idx !== -1) {
                        // console.log('REMOVING KPI', a0);
                        this._kpis.events.splice(idx, 1);
                    }
                    break;
            }
        },

        _applyKPIs: function(o) {
            // console.log('_applyKPIs', o.video, this._preRoll);
            var ev, i, I, f = o.events.length;

            if (this._preRoll) { // we just need to find and fire the preroll event
                for (i = 0; i < f; ++i) {
                    ev = o.events[i];
                    if (ev.event === 'preRoll') {
                        this._pub('metro', ev.endpoint, 'svkpi_preRoll');
                        return;
                    }
                }

                return; //console.log('no preRoll event found?!');
            }

            var sortedProgressEvents = [];
            for (i = 0; i < f; ++i) {
                ev = o.events[i];
                if (ev.event === 'progress') {
                    sortedProgressEvents.push(ev);
                }
            }
            I = sortedProgressEvents.length;

            var sigma = function(n) { return (n < 0) ? -1 : ((n > 0) ? 1 : 0); };
            var sortTimefn = function(b, a) { return sigma(a.time - b.time); };
            sortedProgressEvents.sort(sortTimefn); // sort them desc
            //console.log(sortedProgressEvents);

            var requestURL = this._requestURL;
            var kpiEvents = {};
            var val, k;
            var lastProgressTime = this._md.duration;

            for (i = 0; i < I; ++i) {
                ev = sortedProgressEvents[i];
                // console.log('ADDING TIMELINE at [%s, %s]', ev.time-1, lastProgressTime);
                this._pub('add_timeline',
                    {
                        kind:  'pubs',
                        start: ev.time-1,
                        end:   lastProgressTime,
                        args:  [
                            ['metro', ev.endpoint, 'svkpi_progress'],
                            ['sv_analytics_kill_endpoint', ev]
                        ],
                        once: true,
                        id:   genId('analytics_')
                    },
                    requestURL
                );
                lastProgressTime = ev.time;
            }

            for (i = 0; i < f; ++i) {
                ev = o.events[i];
                switch (ev.event) {
                    case 'start':
                        // console.log('ADDING START TIMELINE at [0, %s]', this._md.duration);
                        this._pub('add_timeline',
                            {
                                kind:  'pubs',
                                start: 0,
                                end:   this._md.duration,
                                args:  [
                                    ['metro', ev.endpoint, 'svkpi_start'],
                                    ['sv_analytics_kill_endpoint', ev]
                                ],
                                once: true,
                                id:   genId('analytics_')
                            },
                            requestURL
                        );
                        break;

                    case 'progress':
                        break;

                    default:
                        k = ev.event;

                        val = kpiEvents[k];
                        if (!val) {
                            kpiEvents[k] = [ev.endpoint];
                        }
                        else {
                            val.push(ev.endpoint);
                        }
                }
            }

            this._kpiEvents = kpiEvents;
        },

        _fetchEndpoints: function() {
            var md = this._md;

            var onSVAnalytics = function(err, o) {
                if (err) { return; }

                try {
                    o = (typeof o === 'string') ? JSON.parse(o) : o;
                    this._cache[md.guid] = o;

                    if (!this._preRoll) {
                        this._kpis = o;
                    }
                    this._applyKPIs(o);
                } catch (ex) {}
            }.bindObj(this);

            if (this._cache[md.guid]) {
                return onSVAnalytics(null, this._cache[md.guid]);
            }

            SAPO.Project.Video.sapoVideosAnalytics({
                protocol:  md.protocol,
                host:      md.domain,
                hash:      md.hash,
                author:    md.author,
                duration:  md.duration,
                autoplay:  this._vc.getOption('autoplay'),
                isInterno: this._vc._inInternoMode,
                pageURI:   Feat.pageURI(),
                teck:      (this._vc.isHtml5() ? 'html5' : 'html5-flash')
            }, onSVAnalytics);
        }

    };

    SAPO.Project.Video.Controllers._plugins.push(plugin);

})(undefined);
